const FormPage = () => {

    return (
        <>
            <h1>Form</h1>
        </>
    )
}

export default FormPage;